import { defineStore } from 'pinia';
import { getUnitMesure } from '@/services/modules/master';

export interface Unit {
  id: number;
  unit: string;
  code: string;
}

export const useUnitStore = defineStore('unit', {
  state() {
    return {
      units: [] as any[]
    };
  },
  actions: {
    async fetchUnits() {
      try {
        const response: any = await getUnitMesure();
        this.units = response as Unit[];
      } catch (e) {
        console.log(e);
      }
    }
  }
});
